// Dialog Manager
class DialogManager {
    constructor() {
        this.init();
    }

    init() {
        // Setup triggers
        document.querySelectorAll('[data-dialog]').forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                const dialogId = e.target.closest('[data-dialog]').dataset.dialog;
                const dialog = document.getElementById(dialogId);
                if (dialog) this.openDialog(dialog);
            });
        });

        // Setup dialogs
        document.querySelectorAll('dialog').forEach(dialog => {
            // Close button
            const closeBtn = dialog.querySelector('.dialog__close');
            if (closeBtn) {
                closeBtn.addEventListener('click', () => this.closeDialog(dialog));
            }

            // Click outside
            dialog.addEventListener('click', (e) => {
                if (e.target === dialog) this.closeDialog(dialog);
            });

            // Prevent propagation from content
            const content = dialog.querySelector('.dialog__content');
            if (content) {
                content.addEventListener('click', (e) => e.stopPropagation());
            }
        });
    }

    openDialog(dialog) {
        dialog.showModal();
    }

    closeDialog(dialog) {
        dialog.classList.add('dialog--closing');
        setTimeout(() => {
            dialog.close();
            dialog.classList.remove('dialog--closing');
        }, 0); // Match CSS transition duration
    }
}

// Embroidery Controller using Module Pattern
const EmbroideryController = (() => {
    let instance;
    
    class EmbroideryManager {
        constructor() {
            this.form = null;
            this.monogramDetails = null;
            this.monogramSummary = null;
            this.dialog = null;
            this.init();
        }

        init() {
            // Initialize form elements
            this.form = document.getElementById('monogramForm');
            this.monogramDetails = document.querySelector('.embroidery__details');
            this.monogramSummary = document.querySelector('[data-embroidery-summary]');
            this.dialog = document.getElementById('embroideryDialog');

            if (!this.form) return; // Exit if form doesn't exist

            // Bind events
            this.bindEvents();
            
            // Initial setup
            const checkedRadio = this.form.querySelector('input[type="radio"]:checked');
            if (checkedRadio) {
                this.updateMonogramSwatches(checkedRadio);
            }
            this.checkAndEnableInputs();
        }

        bindEvents() {
            // Event delegation for clear buttons
            document.addEventListener('click', (e) => {
                if (e.target.matches('[data-monogram-clear]')) {
                    this.clearMonogram();
                }
            });

            // Form submit handler
            this.form.addEventListener('submit', (e) => this.handleFormSubmit(e));

            // Form change handler
            this.form.addEventListener('change', (e) => {
                if (e.target.type === 'radio') {
                    this.updateMonogramSwatches(e.target);
                }
                this.checkAndEnableInputs();
            });
        }

        clearMonogram() {
            this.monogramSummary.innerHTML = '';
            this.monogramDetails.hidden = true;
            this.form.reset();
        }

        handleFormSubmit(e) {
            e.preventDefault();

            const uniqueId = `emb_${Math.random().toString(36).substring(2, 15)}_${Date.now()}`;
            const formData = new FormData(this.form);
            const fragment = document.createDocumentFragment();
            
            // Clear previous summary
            this.monogramSummary.innerHTML = '';

            // Add hidden embroidery ID field with unique string
            // const idInput = document.createElement('input');
            // idInput.type = 'hidden';
            // idInput.name = '_embroidery_id';
            // idInput.value = uniqueId;
            // fragment.appendChild(idInput);

            // Add hidden variant ID field if it exists in form
            const variantId = formData.get('_variant_id');
            if (variantId) {
                // Create hidden input for variant ID
                const variantInput = document.createElement('input');
                variantInput.type = 'hidden';
                variantInput.name = 'embroidery_variant_id';
                variantInput.value = variantId;
                this.monogramSummary.appendChild(variantInput);
                
                // Create variant list item
                // const listItem = document.createElement('li');
                // listItem.dataset.additionalVariant = variantId;
                // this.monogramSummary.appendChild(listItem);
            }

            // Create summary items and hidden inputs
            for (const [key, value] of formData) {
                // Skip empty values and variant_id
                if (!value || key === '_variant_id') continue;

                // Create summary item
                const listItem = document.createElement('li');
                listItem.dataset.property = key;
                listItem.dataset.propertyValue = value;

                const propertySpan = document.createElement('span');
                propertySpan.textContent = key;
                
                const valueSpan = document.createElement('span');
                valueSpan.textContent = value;

                listItem.appendChild(propertySpan);
                listItem.appendChild(valueSpan);
                fragment.appendChild(listItem);
            }

            // Update UI
            this.monogramSummary.appendChild(fragment);
            this.monogramDetails.hidden = false;
            
            // Close dialog
            if (this.dialog) {
                this.dialog.close();
            }
        }

        updateMonogramSwatches(target) {
            const swatchItems = this.form.querySelectorAll('.swatch__item');
            swatchItems.forEach(item => {
                const input = item.querySelector('input[type="radio"]');
                const isChecked = input === target;
                item.classList.toggle('swatch__item--current', isChecked);
                
                if (isChecked && input.dataset.label) {
                    const label = item.closest('.form-section').querySelector('.form-section__label');
                    if (label) {
                        label.textContent = input.dataset.label;
                    }
                }
            });
        }

        checkAndEnableInputs() {
            const formData = new FormData(this.form);
            const enabledInputs = this.form.querySelectorAll('[data-enabled]');

            enabledInputs.forEach(input => {
                const enabledPairs = input.dataset.enabled.split(', ');
                const shouldEnable = enabledPairs.some(pair => {
                    const [key, value] = pair.split(': ').map(s => s.trim());
                    return formData.get(key) === value;
                });

                input.disabled = !shouldEnable;
                
                if (input.type === 'radio') {
                    const radioItem = input.closest('.radio-option');
                    if (radioItem) {
                        radioItem.style.display = shouldEnable ? '' : 'none';
                    }
                } else {
                    input.closest('.form-section').style.display = shouldEnable ? '' : 'none';
                }
            });

            // Auto-select first enabled radio in each group if none selected
            this.form.querySelectorAll('.radio-group').forEach(group => {
                const enabledRadios = Array.from(group.querySelectorAll('input[type="radio"]:not([disabled])'));
                if (enabledRadios.length && !enabledRadios.some(radio => radio.checked)) {
                    enabledRadios[0].checked = true;
                }
            });
        }
    }

    return {
        init() {
            instance = new EmbroideryManager();
        },
        reinitialize() {
            instance = new EmbroideryManager();
        }
    };
})();

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new DialogManager();
        EmbroideryController.init();
    });
} else {
    new DialogManager();
    EmbroideryController.init();
}

// Listen for product switch events
window.addEventListener('productSwitched', () => {
    new DialogManager();
    EmbroideryController.reinitialize();
});